import BaseResource from './index'
import validators from '../utilities/validation'

export default class RuleGroupResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/rulegroups'

    static validation = {
        name: validateName,
    }
}

function validateName(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Code'
        throw validationError + '(' + validationError.field + ')'
    }
}
